var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_c('progress-bar', {
    attrs: {
      "percent": 20
    }
  }), _c('div', {
    staticClass: "center"
  }, [_c('CrossSvg', {
    staticClass: "cross"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(" This SolShare is not supported for over-the-air software update. ")]), _c('div', {
    staticClass: "note"
  }, [_vm._v(" Please contact Allume Technical support for assistance before continuing commissioning. ")])], 1), _c('yellow-button', {
    staticClass: "contact",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v(" CONTACT ALLUME ")]), _c('back-button')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }